import BannerCarousel from "@vfuk/core-banner-carousel";
import Heading from "@vfuk/core-heading";
import CarouselBanner from "@components/home/CarouselBanner";
import bannerImageOne from "@img/home/interactiveVoiceBanner.png";
import bannerImageTwo from "@img/home/unifiedSolutionsBanner.png";
import VFUCSquareImage from "@img/home/VFUC.png";
import IVSquareImage from "@img/home/IV.png";
import tabsBannerImage from "@img/home/Flexible.png";
import CardContainer from "@vfuk/core-container";
import SimpleGrid from "@vfuk/core-simple-grid";
import Container from "@vfuk/core-container";
import LinkWithIcon from "@vfuk/core-link-with-icon";
import Spacing from "@vfuk/core-spacing";
import { Tab, Tabs } from "@vfuk/core-tabs";
import Paragraph from "@vfuk/core-paragraph";
import StandardPage from "@components/common/DashShell";
import { Stack } from "@ucchub/ui";
import styled from "styled-components";

const BulletStyle = styled.div`
  .bAhXMc {
    align-items: flex-start;
  }
`;

const Home = () => {
  const tabsData = [
    {
      id: "tab1",
      name: "Flexible",
      heading: "Flexible",
      desc: `We offer customisable solutions to meet your unique needs. Let us help you achieve your goals with personalised services tailored to your business.`,
    },
    {
      id: "tab2",
      name: "Inclusive",
      heading: "Inclusive",
      desc: `We strive to foster belonging and empowerment at work. We create relevant marketing for our diverse customers. We listen and engage with our diverse communities. And we value teamwork with our diverse suppliers.`,
    },
    {
      id: "tab3",
      name: "Secure",
      heading: "Secure",
      desc: `We take security seriously, with state-of-the-art measures in place to protect your data and assets. Trust us to safeguard your business and give you peace of mind.`,
    },
    {
      id: "tab4",
      name: "24x7 support",
      heading: "24x7 support",
      desc: `Our company provides 24x7 service for all your needs, ensuring that you have access to our support team around the clock. With us, you can rest assured that help is always just a phone call or email away.`,
    },
  ];

  const productsData = [
    {
      id: "1",
      src: IVSquareImage,
      heading: "Interactive Voice",
      desc: `Manage and route your inbound numbers quickly and easily, all in one place.`,
      href: " https://www.vodafone.com/business/solutions/unified-communication/vodafone-business-interactive-voice",
    },
    {
      id: "2",
      src: VFUCSquareImage,
      heading: "Cloud Numbers",
      desc: `With our self-serve portal, easily manage cloud numbers based on your use case and open your business to new possibilities.`,
      href: " https://www.vodafone.com/business/wholesale-services/international-voice/vodafone-cloud-numbers",
    },
  ];

  return (
    <StandardPage>
      <BulletStyle>
        <BannerCarousel
          srName="Banner Carousel"
          waitTime={3000}
          showNavigation
          banners={[
            {
              title: "Interactive voice",
              child: (
                <CarouselBanner
                  headingText="Centralised portal for everything. And everyone."
                  src={bannerImageOne}
                  key={0}
                  primaryButtonHref="https://www.vodafone.com/business/solutions/unified-communication/vodafone-business-interactive-voice"
                  primaryButtonText="Find out more"
                />
              ),
            },
            {
              title: "Unified communications solutions for business",
              child: (
                <CarouselBanner
                  headingText="Unified communications solutions for business."
                  src={bannerImageTwo}
                  key={1}
                  primaryButtonHref="https://www.vodafone.com/business/solutions/unified-communications"
                  primaryButtonText="Find out more"
                />
              ),
            },
          ]}
        />
        <section>
          <Spacing spacingLevel={{ bottom: 4, top: 3, left: 4 }}>
            <Heading size={2} weight={3} text="Featured products" />
          </Spacing>
          <Container appearance="secondary">
            <SimpleGrid
              columns={{
                sm: 1,
                md: 2,
              }}
              spacing={3}
              verticalAlign="stretch"
            >
              {productsData.map((pData) => (
                <CardContainer paddingLevel={5} elevation key={pData.id}>
                  <Stack
                    align="stretch"
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Stack
                      direction="column"
                      align="flex-start"
                      justifyContent="space-between"
                    >
                      <div>
                        <Heading
                          level={4}
                          weight={3}
                          noMargin
                          text={pData.heading}
                        />

                        <Spacing spacingLevel={{ top: 4 }}>
                          <Heading
                            level={5}
                            weight={2}
                            noMargin
                            text={pData.desc}
                          />
                        </Spacing>
                      </div>

                      <LinkWithIcon
                        appearance="secondary"
                        text="Know more"
                        icon={{
                          name: "chevron-right",
                          justify: "right",
                        }}
                        href={pData.href}
                      />
                    </Stack>

                    <img
                      src={pData.src}
                      alt={pData.heading + " image"}
                      width="200px"
                      height="200px"
                    />
                  </Stack>
                </CardContainer>
              ))}
            </SimpleGrid>
          </Container>
          <Spacing spacingLevel={{ top: 3, bottom: 3, left: 4 }}>
            <Heading size={2} weight={3} text="Why choose UC by Vodafone?" />
          </Spacing>
        </section>
        <div>
          <CardContainer>
            <Stack align="stretch">
              <Spacing spacingLevel={{ right: 12 }}>
                <Tabs>
                  {tabsData.map((tabss) => (
                    <Tab text={tabss.name} id={tabss.id} key={tabss.id}>
                      <Spacing spacingLevel={{ top: 8 }}>
                        <Heading level={2} weight={2} text={tabss.heading} />
                        <Paragraph size={2}>{tabss.desc}</Paragraph>
                      </Spacing>
                    </Tab>
                  ))}
                </Tabs>
              </Spacing>

              <img
                src={tabsBannerImage}
                height="500px"
                alt="UC Hub Banner Image"
              />
            </Stack>
          </CardContainer>
        </div>
      </BulletStyle>
    </StandardPage>
  );
};

export default Home;
